<template>
  <div
    ref="layoutRef"
    :class="layoutClasses"
    :data-columns="props.divided ? columnCount : undefined"
    data-cy="ds-grid__layout"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { useResizeObserver } from "@vueuse/core";
import type { DSGridLayoutProps } from "../types/props";
import { DS_GRID_LAYOUT_DISTRIBUTION } from "../types/modes";
import { DISTRIBUTION_TO_CLASS_MAP } from "@/src/design_system/layouts_and_containers/grid/constants/mode";
import { DS_GRID_CLASSES } from "@/src/design_system/layouts_and_containers/grid/constants/classes";

const props = withDefaults(defineProps<DSGridLayoutProps>(), {
  distribution: DS_GRID_LAYOUT_DISTRIBUTION.Cols1,
  dense: false,
  divided: false,
});

const layoutRef = ref<HTMLElement>();
const columnCount = ref<number>();

const layoutClasses = computed(() => [
  DS_GRID_CLASSES.Layout,
  DISTRIBUTION_TO_CLASS_MAP[props.distribution],
  { [DS_GRID_CLASSES.LayoutDense]: props.dense, [DS_GRID_CLASSES.LayoutDivided]: props.divided },
]);

// `:nth-last-child()` cannot read a custom property, so the stylesheet hides the last row's dividers by this attribute.
useResizeObserver(
  computed(() => (props.divided ? layoutRef.value : undefined)),
  ([entry]) => {
    columnCount.value = getComputedStyle(entry.target).gridTemplateColumns.split(" ").length;
  }
);
</script>
